import { render, staticRenderFns } from "./Boletas.vue?vue&type=template&id=a045e47a&scoped=true&"
import script from "./Boletas.vue?vue&type=script&lang=js&"
export * from "./Boletas.vue?vue&type=script&lang=js&"
import style0 from "./Boletas.scss?vue&type=style&index=0&id=a045e47a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a045e47a",
  null
  
)

export default component.exports